import React from 'react';
import Header from '@/lighting-app/components/Header';
import HeroSection from './app-components/HeroSection';
import MainCTACards from './app-components/MainCTACards';
import HowItWorks from './app-components/HowItWorks';
import StatsSection from './app-components/StatsSection';

export default function HomePage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <HeroSection />
        <MainCTACards />
        <HowItWorks />
        <StatsSection />
      </main>
    </div>
  );
}